import errorHandler from "../../handlers/errorHandler";
import successHandler from "../../handlers/successHandler";
import { revenueWalletService } from "../../services/revenueWallet.service";
import revenueWalletType from "./revenueWalletTypes";

/**
 * Get all revenue payout
 **/

export const getAllRevenuePayout = (page) => async (dispatch) => {
  try {
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: true,
    });
    const response = await revenueWalletService.getAllRevenuePayout(page);
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: false,
    });
    dispatch({ type: revenueWalletType["ALL_REFERRALS"], payLoad: response });
  } catch (error) {
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: false,
    });
  }
};

/**
 * Get a revenue payout
 **/

export const showARevenuePayout = (id) => async (dispatch) => {
  try {
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: true,
    });
    const response = await revenueWalletService.showARevenuePayout(id);
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: false,
    });
    dispatch({ type: revenueWalletType["ALL_REFERRALS"], payLoad: response });
  } catch (error) {
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: false,
    });
  }
};

/**
 * Get all referrals
 **/

export const getAllRevenuePayoutsNoPagination =
  (payload, page) => async (dispatch) => {
    try {
      dispatch({ type: revenueWalletType["DOWNLOADING"], payLoad: true });
      const response =
        await revenueWalletService.getAllRevenuePayoutsNoPagination(
          payload,
          page,
        );
      dispatch({ type: revenueWalletType["DOWNLOADING"], payLoad: false });
      // dispatch({ type: revenueWalletType["ALL_REFERRALS"], payLoad: response });
      return response;
    } catch (error) {
      dispatch({ type: revenueWalletType["DOWNLOADING"], payLoad: false });
    }
  };

/**
 * Search referrals
 **/

export const searchRevenuePayout = (payload) => async (dispatch) => {
  try {
    dispatch({ type: revenueWalletType["SEARCHING"], payLoad: true });
    const response = await revenueWalletService.searchRevenuePayout(payload);
    dispatch({ type: revenueWalletType["SEARCHING"], payLoad: false });
    dispatch({
      type: revenueWalletType["SEARCH_REFERRALS"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({ type: revenueWalletType["SEARCHING"], payLoad: false });
  }
};

/**
 * Filter referrals
 **/

export const filterRevenueWallet = (payload, page) => async (dispatch) => {
  try {
    dispatch({
      type: revenueWalletType["FILTERING_REVENUE_WALLET"],
      payLoad: true,
    });
    const response = await revenueWalletService.filterRevenueWallet(
      payload,
      page,
    );
    dispatch({
      type: revenueWalletType["FILTERING_REVENUE_WALLET"],
      payLoad: false,
    });
    dispatch({
      type: revenueWalletType["FILTER_REVENUE_WALLET"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: revenueWalletType["FILTERING_REVENUE_WALLET"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

/**
 * Edit revenue payout
 **/

export const editRevenuePayout = (payload, page) => async (dispatch) => {
  try {
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: true,
    });
    const response = await revenueWalletService.editRevenuePayout(
      payload,
      page,
    );
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: false,
    });
    dispatch({
      type: revenueWalletType["FILTER_REFERRALS"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

/**
 * store revenue payout
 **/

export const storeRevenuePayout = (payload, page) => async (dispatch) => {
  try {
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: true,
    });
    const response = await revenueWalletService.storeRevenuePayout(
      payload,
      page,
    );
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: false,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({
      type: revenueWalletType["LOADING_REVENUE_WALLET"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};
